export default "__VITE_ASSET__BYHJW1Vo__"